/*
 * lw-cart-variant.js — in-drawer variant switcher (Tony 2026-08-06)
 * A chip on each multi-variant cart line opens a slide-in sheet where the
 * shopper re-picks size / colour / weight and we swap the cart line via the
 * AJAX cart API — no trip to the product page. Loaded once as an external
 * asset so the document-level delegation survives the drawer's innerHTML
 * re-renders (inline <script> tags injected via innerHTML never re-execute).
 */
(function () {
  if (window.__lwCartVariant) return;
  window.__lwCartVariant = true;

  // --- zeedog-style qty control: the trash icon replaces the minus button when
  // qty is 1. We only toggle a class (.lw-q1); CSS shows the native remove
  // button and hides minus, so no Dawn quantity behaviour is modified. ---
  function lwQtyMode() {
    document.querySelectorAll('#CartDrawer .cart-item, #main-cart-items .cart-item').forEach(function (item) {
      var input = item.querySelector('.quantity__input');
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      item.classList.toggle('lw-q1', v <= 1);
    });
  }
  function lwWatchCart() {
    var t;
    ['cart-drawer', '#main-cart-items'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(lwQtyMode, 60); })
        .observe(el, { childList: true, subtree: true });
    });
    lwQtyMode();
  }
  if (document.readyState !== 'loading') lwWatchCart();
  else document.addEventListener('DOMContentLoaded', lwWatchCart);

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var panel = null;
  var state = null; // {product, lineKey, currentVariantId, qty, selected:[]}

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function closeSvg() {
    return '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  }
  function postJSON(body) {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    };
  }
  function optName(o) { return typeof o === 'string' ? o : o.name; }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('.lw-vchip');
    if (chip) { e.preventDefault(); openPicker(chip); return; }
    if (!panel) return;
    if (e.target.closest('.lw-vpick__close') || e.target.closest('.lw-vpick__scrim')) { closePicker(); return; }
    var opt = e.target.closest('.lw-vpick__opt');
    if (opt) { selectOption(opt); return; }
    var q = e.target.closest('.lw-vpick__qty [data-step]');
    if (q) { stepQty(parseInt(q.getAttribute('data-step'), 10)); return; }
    if (e.target.closest('.lw-vpick__update')) { commit(); return; }
  });

  async function openPicker(chip) {
    var handle = chip.getAttribute('data-handle');
    var lineKey = chip.getAttribute('data-line-key');
    var currentVariantId = parseInt(chip.getAttribute('data-variant-id'), 10);
    var qty = parseInt(chip.getAttribute('data-qty'), 10) || 1;
    var product;
    try {
      product = await fetch(root + 'products/' + handle + '.js').then(function (r) { return r.json(); });
    } catch (err) { return; }
    var current = product.variants.find(function (v) { return v.id === currentVariantId; }) || product.variants[0];
    var context = chip.closest('#CartDrawer') ? 'drawer' : 'page';
    state = { product: product, lineKey: lineKey, currentVariantId: currentVariantId, qty: qty, selected: (current.options || []).slice(), context: context };
    renderPanel();
  }

  function matchVariant() {
    return state.product.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === state.selected[i]; });
    });
  }
  // best variant when only option i is pinned to val (keep other current picks)
  function variantForValue(i, val) {
    var sel = state.selected.slice(); sel[i] = val;
    return state.product.variants.find(function (v) {
      return v.options.every(function (o, k) { return o === sel[k]; });
    }) || state.product.variants.find(function (v) { return v.options[i] === val && v.available; })
      || state.product.variants.find(function (v) { return v.options[i] === val; });
  }

  function renderPanel() {
    var p = state.product;
    var names = p.options.map(optName);
    var groups = names.map(function (name, i) {
      var vals = [];
      p.variants.forEach(function (v) { if (vals.indexOf(v.options[i]) === -1) vals.push(v.options[i]); });
      var chips = vals.map(function (val) {
        var active = state.selected[i] === val;
        var cand = variantForValue(i, val);
        var sold = cand && !cand.available;
        return '<button type="button" class="lw-vpick__opt' + (active ? ' is-active' : '') + (sold ? ' is-soldout' : '') +
          '" data-oi="' + i + '" data-val="' + esc(val) + '">' + esc(val) + '</button>';
      }).join('');
      return '<div class="lw-vpick__group"><p class="lw-vpick__label">' + esc(name) + '</p><div class="lw-vpick__opts">' + chips + '</div></div>';
    }).join('');

    var matched = matchVariant();
    var img = (matched && matched.featured_image && matched.featured_image.src) || p.featured_image || (p.images && p.images[0]) || '';
    var soldout = !matched || !matched.available;
    var priceStr = matched ? money(matched.price) : '';

    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'lw-vpick';
      document.body.appendChild(panel);
    }
    panel.innerHTML =
      '<div class="lw-vpick__scrim"></div>' +
      '<div class="lw-vpick__sheet" role="dialog" aria-modal="true" aria-label="Choose options">' +
        '<div class="lw-vpick__head">' +
          '<h2 class="lw-vpick__title">Choose options</h2>' +
          '<button type="button" class="lw-vpick__close" aria-label="Close">' + closeSvg() + '</button>' +
        '</div>' +
        '<div class="lw-vpick__body">' +
          '<div class="lw-vpick__hero">' + (img ? '<img src="' + img + '" alt="" width="130" height="130">' : '') + '</div>' +
          '<a class="lw-vpick__full" href="' + p.url + '">View full page</a>' +
          '<h3 class="lw-vpick__pname">' + esc(p.title) + '</h3>' +
          groups +
        '</div>' +
        '<div class="lw-vpick__foot">' +
          '<div class="lw-vpick__qty">' +
            '<button type="button" data-step="-1" aria-label="Decrease">−</button>' +
            '<span class="lw-vpick__qtyn">' + state.qty + '</span>' +
            '<button type="button" data-step="1" aria-label="Increase">+</button>' +
          '</div>' +
          '<button type="button" class="lw-vpick__update"' + (soldout ? ' disabled' : '') + '>' +
            (soldout ? 'Unavailable' : 'Update bag · ' + priceStr) +
          '</button>' +
        '</div>' +
      '</div>';
    requestAnimationFrame(function () { panel.classList.add('is-open'); });
  }

  function selectOption(el) {
    var i = parseInt(el.getAttribute('data-oi'), 10);
    state.selected[i] = el.getAttribute('data-val');
    if (!matchVariant()) {
      var fb = state.product.variants.find(function (v) { return v.options[i] === state.selected[i] && v.available; }) ||
        state.product.variants.find(function (v) { return v.options[i] === state.selected[i]; });
      if (fb) state.selected = fb.options.slice();
    }
    renderPanel();
  }

  function stepQty(delta) {
    state.qty = Math.max(1, state.qty + delta);
    renderPanel();
  }

  async function commit() {
    var matched = matchVariant();
    if (!matched || !matched.available) return;
    var btn = panel.querySelector('.lw-vpick__update');
    if (btn) { btn.disabled = true; btn.textContent = 'Updating…'; }
    try {
      if (matched.id === state.currentVariantId) {
        await fetch(root + 'cart/change.js', postJSON({ id: state.lineKey, quantity: state.qty }));
      } else {
        var addRes = await fetch(root + 'cart/add.js', postJSON({ items: [{ id: matched.id, quantity: state.qty }] }));
        if (!addRes.ok) throw new Error('add failed');
        await fetch(root + 'cart/change.js', postJSON({ id: state.lineKey, quantity: 0 }));
      }
      if (state.context === 'page') { window.location.reload(); return; }
      await refreshDrawer();
    } catch (err) {
      if (btn) { btn.disabled = false; btn.textContent = 'Try again'; }
      return;
    }
    closePicker();
  }

  async function refreshDrawer() {
    var res = await fetch(root + '?sections=cart-drawer,cart-icon-bubble');
    var data = await res.json();
    function pick(html, sel) {
      try { return new DOMParser().parseFromString(html, 'text/html').querySelector(sel); } catch (e) { return null; }
    }
    var cd = pick(data['cart-drawer'], '#CartDrawer');
    var target = document.querySelector('#CartDrawer');
    if (cd && target) {
      target.innerHTML = cd.innerHTML;
      var ov = target.querySelector('#CartDrawer-Overlay');
      if (ov) ov.addEventListener('click', function () { var d = document.querySelector('cart-drawer'); if (d) d.close(); });
    }
    var bubble = pick(data['cart-icon-bubble'], '#cart-icon-bubble');
    var bt = document.querySelector('#cart-icon-bubble');
    if (bubble && bt) bt.innerHTML = bubble.innerHTML;
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      // Swapping #CartDrawer's innerHTML leaves <cart-drawer>'s own classes
      // alone, so is-empty has to be re-derived from the markup we just wrote
      // — same reason as the toggle in cart-drawer.js renderContents.
      drawer.classList.toggle('is-empty', !drawer.querySelector('.cart-item'));
      if (!drawer.classList.contains('active')) drawer.classList.add('animate', 'active');
    }
  }

  function closePicker() {
    if (!panel) return;
    var p = panel;
    p.classList.remove('is-open');
    setTimeout(function () { p.remove(); }, 280);
    panel = null;
    state = null;
  }
})();
